// notifications must be of form { type, message }

export const NotificationType = Object.freeze({
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
})

export const namespaced = true

export const state = {
  notifications: [],
}

export const getters = {}

let nextId = 1

export const mutations = {
  push: (state, notification) => state.notifications.push({ ...notification, id: nextId++ }),
  delete: (state, notificationToRemove) =>
    (state.notifications = state.notifications.filter(n => n.id !== notificationToRemove.id)),
}

export const actions = {
  add: ({ commit }, notification) => commit('push', notification),
  remove: ({ commit }, notification) => commit('delete', notification),
}
